
import { useState, createContext, useContext , useRef ,  lazy, Suspense  } from "react";
import { Link , NavLink  } from "react-router-dom";
import Quickbuy from '../quickbuy/QuickBuy';
import Favorite from '../favorite/Favorite';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import  { WebAssetsContext }  from "../../App";
import OrderForm from "../Leftsection/OrderForm";
import  { loaderBar , apibaseURl , currencySymbol }  from "../../functions/Function";
const  LeftSection = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const [activetab, setActivetab] = useState('quick');
  const activeTab = useRef('quick');

  const handleActiveTab = (activetab) =>
  {
    setActivetab(activetab)
  }
   

  return (
    <> 
    
    <div className="col-lg-3">
        <div className="ivo-left-index  trade-shadow-box">
          <nav className="ivo-buy-sell-tabs">
            <div className="nav nav-tabs" id="nav-tab">
                <button onClick={()=>handleActiveTab('quick')}
                className={activetab == 'quick' ? 'ivo-buy-single nav-link active' : 'ivo-buy-single nav-link' }>QUICK BUY</button>
                
                <button onClick={()=>handleActiveTab('fav')} className={activetab =='fav' ? 'nav-link ivo-buy-single active' : 'nav-link ivo-buy-single' }  >FAVOURITE</button>
            </div>
          </nav>
          
          {activetab == 'quick' &&
             
                <Quickbuy key={11} active={activetab} handleClickActiveProduct={props.handleClickActiveProduct} />
           
          }

          {activetab == 'fav' &&
             <Favorite key={12} active={activetab} handleClickActiveProduct={props.handleClickActiveProduct} />
          }
          
         
          
      </div>
      <div className="ivo-buy-sell-form mt-2 trade-shadow-box">
          

            <OrderForm activeproduct={props.activeproduct}/>

      </div>
    </div>
   
       
    </>

  );
}

export default LeftSection;
